export default "__VITE_ASSET__DtGMNUBj__"